import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import buyerService from "../../services/buyerService";

export const fetchBuyers=createAsyncThunk(
    "buyers/fetch",
    async()=>{

        return await buyerService.getBuyers();

    }
);

export const removeBuyer=createAsyncThunk(
    "buyers/delete",
    async(id)=>{
        await buyerService.deleteBuyer(id);
        return id;
    }
);

export const addBuyer = createAsyncThunk(
    "buyers/add",
    async (formData, thunkAPI) => {
        try {
            return await buyerService.addBuyer(formData);
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message
            );
        }
    }
);

const buyerSlice=createSlice({

    name:"buyers",

    initialState:{
        buyers:[],
        loading:false
    },

    reducers:{},

    extraReducers:(builder)=>{

        builder

.addCase(fetchBuyers.pending,(state)=>{
    state.loading=true;
})

.addCase(fetchBuyers.fulfilled,(state,action)=>{
    state.loading=false;
    state.buyers=action.payload;
})

.addCase(fetchBuyers.rejected,(state)=>{
    state.loading=false;
})

.addCase(addBuyer.fulfilled,(state,action)=>{

    state.buyers.unshift(action.payload);

})

.addCase(removeBuyer.fulfilled,(state,action)=>{

    state.buyers=
    state.buyers.filter(
        x=>x._id!==action.payload
    );

});

    }

});

export default buyerSlice.reducer;